import { Component, OnInit } from '@angular/core'
import { Input } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSourceSummary } from 'src/app/models/latest-aggregate-amounts.model'
import {
  getFacebookFollowers,
  getLoading,
} from 'src/app/selectors/latest-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByFacebookFollower,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-facebook-follower',
    templateUrl: './aggregated-amounts-facebook-follower.component.html',
    styleUrls: ['./aggregated-amounts-facebook-follower.component.scss'],
    standalone: false
})
export class AggregatedAmountsFacebookFollowerComponent implements OnInit {
  facebookFollowers$: Observable<CountableSourceSummary[]>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  @Input() url: string

  ngOnInit() {
    this.facebookFollowers$ = this.store.select(getFacebookFollowers)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByFacebookFollower)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
